module.exports = __webpack_public_path__ + "img/arrow-down.1b358f68.svg";